import { render, staticRenderFns } from "./ShownSubscription.vue?vue&type=template&id=2ceb820f&scoped=true&"
import script from "./ShownSubscription.vue?vue&type=script&lang=ts&"
export * from "./ShownSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./ShownSubscription.vue?vue&type=style&index=0&id=2ceb820f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb820f",
  null
  
)

export default component.exports